import axiosInstance from '@/app/api/axiosInstance'
import {
  OrganizationSettingResponse,
  OrganizationSettingUpdate
} from '@/app/types/organizationSettings'

export const getOrganizationSettings = async (): Promise<OrganizationSettingResponse> => {
  try {
    const response = await axiosInstance.get<OrganizationSettingResponse>(
      '/organization-settings/'
    )
    return response.data
  } catch (error: any) {
    console.error('Failed to get organization settings:', error)

    // If 404, return default empty settings
    if (error.response?.status === 404) {
      console.warn('Organization settings endpoint not found (404). Returning default settings.')
      // Return a minimal valid response with required fields
      return {
        id: 0,
        organization_id: 0
      } as OrganizationSettingResponse
    }

    throw error
  }
}

export const updateOrganizationSettings = async (
  data: OrganizationSettingUpdate
): Promise<OrganizationSettingResponse> => {
  try {
    const response = await axiosInstance.patch<OrganizationSettingResponse>(
      '/organization-settings/',
      data
    )
    return response.data
  } catch (error) {
    console.error('Failed to update organization settings:', error)
    throw error
  }
}
